module.exports = __webpack_public_path__ + "static/media/cppLogo.e4f46516.png";